package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.pages.LoginPage
import games.polyclub.website.frontend.store.pages.UnauthorizedPage
import react.Props
import react.router.Outlet

external interface RequireAuthProps: Props {
    var allowedRoles: Set<String>?
}

val RequireAuth = SFC<RequireAuthProps> { props ->
    val ctx = useAuth()

    if (ctx.auth?.accessToken == null) {
        LoginPage()
    } else {
        val allowedRoles = props.allowedRoles
        if (allowedRoles?.isEmpty() != false || ctx.auth?.roles?.any { it in allowedRoles } == true) {
            Outlet()
        } else {
            UnauthorizedPage()
        }
    }
}
